import { factoryService, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { getCookie } from '@chilecompra/react-kit'

/**
 * Gets the agreements.
 */
export const getAbility = factoryService(({ providerId, convenioId }) => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/busquedaHabilidadProveedor/${providerId}/${convenioId}`
  )
})

/**
 * Gets the agreements.
 */
export const getAgreement = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/convenioMarco`)
})

/**
 * Gets the agreements.
 */
export const getProducts = factoryService(body => {
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/getProductsPost`, {
    body,
    customHeaders: { 'X-XSRF-TOKEN': getCookie('X-XSRF-TOKEN') }
  })
})

/**
 * Gets the requests.
 */
export const getRequests = factoryService(body => {
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/requestList`, {
    body,
    customHeaders: { 'X-XSRF-TOKEN': getCookie('X-XSRF-TOKEN') }
  })
})

/**
 * Dowload the requests.
 */
export const downloadRequests = factoryService(body => {
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/requestListDownload`, {
    body,
    customHeaders: {
      'X-XSRF-TOKEN': getCookie('X-XSRF-TOKEN'),
      'Content-Disposition': 'attachment; filename="requestListDownload.csv"',
      Accept: 'application/csv'
    }
  })
})

/**
 * Gets the TP.
 */
export const getProductsType = factoryService(({ id }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/getTPByIdConvenioMarco/${id}`)
})

/**
 * Get the rut.
 */
export const getRut = factoryService(({ providerId }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/busquedarut/${providerId}`)
})

/**
 * Create requests from selected products.
 */
export const postCreateRequest = factoryService(body => {
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/requestList/create`, {
    body,
    customHeaders: { 'X-XSRF-TOKEN': getCookie('X-XSRF-TOKEN') }
  })
})

/**
 * Gets Config agreements.
 */
export const getAgreementConfig = factoryService(({ id }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/config/${id}`)
})

/**
 * Gets Active offer by product
 */
export const getActiveOffer = factoryService(payload => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/getSpecialOfferData/${payload.data.sku}/${payload.data.orgCode}/${payload.data.agreement}`,
    {
      customHeaders: { 'X-XSRF-TOKEN': getCookie('X-XSRF-TOKEN') }
    }
  )
})
